<template>
  <div class="pipe-list bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <div class="flex items-center mb-10px h-32px leading-32px">
      <img src="../../../assets/images/titleIcon.png" alt />
      <div class="text-16px text-[#fff] ml-5px">物料清单</div>
    </div>
    <el-table
      ref="markerTable"
      :data="tableData"
      class="markerTable mt-10px"
      height="calc(100% - 80px)"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      highlight-current-row
      v-loading="tableLoading"
    >
      <el-table-column show-overflow-tooltip prop="code" label="物资编码"></el-table-column>
      <el-table-column show-overflow-tooltip prop="description" label="物资描述"></el-table-column>
      <el-table-column show-overflow-tooltip prop="unit" label="单位"></el-table-column>
      <el-table-column show-overflow-tooltip prop="quantity" label="数量"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { filter } from 'lodash'
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'

const threeDimensionsApi = new ThreeDimensionsApi()

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
    }
  },
  watch: {
    'transferProps.id': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getMetarialList()
        }
      },
    },
  },
  computed: {},
  async created() {
    if (this.transferProps.id) {
      this.getMetarialList()
    }
  },
  methods: {
    // 获取阀门清单
    // 获取详情清单
    async getMetarialList() {
      this.tableLoading = true
      const [err, res] = await threeDimensionsApi.getMaterialByTagId({
        tagId: this.transferProps.id,
      })
      this.tableLoading = false
      if (!err && res && res.code === '200' && res.data) {
        this.tableData = res.data
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
</style>
